<template>
    <div id="app" v-bind:class="page.parent_user">
        <div class="hotline-launcher h-open" style="display: none;">
            <app-content v-if="first_component=='chat'" v-bind:page="page" v-bind:lang="lang"
                @new_message_number="new_message_number = $event"></app-content>
            <app-survey v-if="first_component=='survey'" v-bind:page="page"></app-survey>
        </div>
        <!-- <div class="d-hotline h-btn animated zoomIn" v-on:click="showLauncher()" > 
      <div v-if="page.button" class="button-custom">
        <div v-if="new_message_number>0" class="new-message-number">{{new_message_number}}</div>
        <i class="icon-ic_chat_icon">
          <img :src="page.button" alt="logo">
        </i>
        <div class=""></div>
      </div>
      <div v-else :style="{'background-color':page.color}" class="button-omni">
        <div v-if="new_message_number>0" class="new-message-number">{{new_message_number}}</div>
        <i class="icon-ic_chat_icon">
          <img src="https://omnisales.worldfone.vn/portal/assets/images/logo_omni_live.png" alt="">
        </i>
        <div class=""></div>
      </div>

    </div> -->

    </div>
</template>

<script>

    import Chat from './components/chat.vue';
    import Survey from './components/survey.vue';
    import Channel from './components/channel.vue';
    import io from 'socket.io-client';
    import axios from 'axios';

    export default {
        name: 'app',
        data() {
            return {
                // show_launcher: 0,
                new_message_number: 0,
                // first_component: '',
                survey: [],
                page: [],
                has_survey: false,
                has_channel: false,
                current_time_m: ENV.current_time,
                current_time_n: ENV.current_time,
                timer: '',
                conditions: [
                    {
                        "type": "location",
                        "data": [
                            "Hà Nội",
                            "Hồ Chí Minh"
                        ]
                    }
                ],
                // lang: 'vi'

            }
        },
        components: {
            'app-content': Chat,
            'app-survey': Survey,
        },
        computed: {
            lang() {
                return this.$store.state.lang;
            },
            st_token() {
                return this.$store.state.st_token;
            },
            show_launcher() {
                return this.$store.state.show_launcher;
            },
            first_component() {
                return this.$store.state.first_component;
            },
        },
        watch: {
            lang: {
                handler(val) {
                    this.swithLang(val);
                    // window.livechat.setSettingLanguage(val);
                },
                deep: true
            }
            /*lang: function(val){
              this.swithLang(val);
              window.livechat.setSettingLanguage(val);
            },*/
        },
        created() {
            if (typeof livechat.getId() === 'undefined') {
                this.$destroy();
                return;
            }

            // top.postMessage({ready: 1}, document.referrer);
        },

        async mounted() {
            var $self = this;
            await this.get_livechat();

            window.onfocus = () => {
                $self.$store.commit('set_hasFocus', true);
            };
            window.onblur = () => {
                $self.$store.commit('set_hasFocus', false);
            };

            function receiveMessage(event) {
                if (typeof (event.data['user_data']) !== 'undefined') {
                   
                    window.user.setId(event.data['user_data'].id);
                    window.user.setName(event.data['user_data'].name);
                    window.user.setPhone(event.data['user_data'].phone);
                    window.user.setEmail(event.data['user_data'].email);
                    window.user.setAddress(event.data['user_data'].address);
                    window.user.setLocale(event.data['user_data'].locale);
                   
                    var properties = [];
                    for (var i in event.data['user_data'].properties) {
                        properties.push({
                            name: i,
                            value: event.data['user_data'].properties[i]
                        });
                    };

                    var livechat_info = event.data['user_data'].livechat_info;
                    if (window.user.id) {
                        var $user_id = $self.get_user_info(window.user.id);
                    }else{
                        //check xem có tồn tại local user_id hay ko
                        // nếu có thì

                        // if($self.lsTest() === true){
                        var st_token = livechat.getSetttinglocalStorage(livechat.getId()+'_omnichat', 'st_token');
                        if (st_token) {
                          // $self.first_component = 'chat';
                          $self.$store.commit('set_first_component', 'chat');
                          $self.$store.commit('set_token', st_token);
                        }else{
                          var user_id = livechat.getSetttinglocalStorage(livechat.getId()+'_omnichat', 'user_id');
                          // nếu ko empty thì clear đi boi vì khách ko set user_id
                          if (user_id) {
                            $self.$store.commit('set_first_component','survey');
                            $self.$store.commit('set_token', '');
                            livechat.addSetttinglocalStorage(livechat.getId()+'_omnichat', 'st_token', "");
                            livechat_info = null;
                          }else if (typeof livechat_info !== 'undefined' && livechat_info!== null){
                            livechat_info = JSON.parse(event.data['user_data'].livechat_info);
                            $self.$store.commit('set_first_component','chat');
                            $self.$store.commit('set_token', livechat_info.st_token);
                          }else{
                              if ($self.st_token) {
                              }else{
                              if ($self.st_token) {
                              } else {
                                if ($self.page.onoff_surver == 1) {
                                  $self.$store.commit('set_first_component', 'survey');
                                  $self.$store.commit('set_token', '');
                                }
                                if ($self.page.onoff_surver!='1') {
                                  // $self.has_survey = false;
                                  $self.$store.commit('set_first_component', 'chat');
                                }
                              }
                            }
                            
                          }
                        }
                    }

        

                    window.user.setProperties(properties);
                    if (event.data['user_data'].name !='' || event.data['user_data'].phone !='' || event.data['user_data'].email !='' || event.data['user_data'].address !='' || !window.livechat.isEmpty(properties)) {
                    window.livechat.sethasUserdata(true);
                    }


               

                    window.livechat.setLanguages(event.data['user_data'].languages);

                }
                if (typeof (event.data['setParentWindowInfo']) !== 'undefined') {
                    var ParentWindowInfo = event.data['setParentWindowInfo'];
                    window.livechat.setParentWindowInfo(ParentWindowInfo);
                }

                if (typeof (event.data['st_popup_status']) !== 'undefined') {//an hien popup
                    $self.showLauncher();
                    if (window.livechat.setting_language === null || window.livechat.setting_language == '') {
                        $self.lang = $self.lang;
                    } else {
                        $self.$store.commit('set_lang', window.livechat.setting_language);
                    }
                    $self.swithLang($self.lang);
                }
            }
            window.addEventListener("message", receiveMessage, false);

        },
        methods: {
            strReplace(str) {
                const replacements = {
                    '{': '&#123;',
                    '}': '&#125;',
                    '$': '&#36;',
                    '\\': '&#92;',
                    '@':'&#64;',
                    // '>':'&#62;',
                    // '<':'&#60;',
                };
                return str.replace(/[{}$\\@]/g, (match) => replacements[match]);
            },
            get_livechat() {
                var $self = this;
                axios.get('/app/v1/public/v2/getlivechat', {
                    params: {
                        livechat_id: livechat.getId(),
                        // st_token: $self.st_token,
                    }
                }).then((response) => {
                    if (response.data.status == 1) {
                        
                        if (this.isMobile() && response.data.data.show_on_mobile == 0) {
                            return false;
                        } else if (!this.isMobile() && response.data.data.show_on_desktop == 0) {
                            return false;
                        }

                        var data = response.data.data;
                  
                        var checkconditions1 = $self.checkconditions(data);//true
                        if (!checkconditions1) {
                            return false;
                        }
                        if(response.data.data.check_domain != undefined && response.data.data.check_domain==1){
                            let hostname = document.referrer;
                                hostname = hostname.replace('https://','');
                                hostname = hostname.replace('http://','');
                                hostname = hostname.split("/");
                            let check_domain=0;
                            if(typeof response.data.data.page_info.website_url =='string'){
                                url=response.data.data.page_info.website_url;
                                let  url = url.replace('https://','');
                                url= url.replace('http://','');
                                let dataUrl=url.split("/");
                                if(hostname[0]==dataUrl[0]){
                                    check_domain+=1;
                                }
                            }else{
                                let website_url=response.data.data.page_info.website_url;
                                website_url.forEach(element => {
                                    let  url = element.replace('https://','');
                                    url= url.replace('http://','');
                                    let dataUrl=url.split("/");
                                    if(hostname[0]==dataUrl[0]){
                                        check_domain+=1;
                                    }
                                });
                            }
                            if(check_domain==0){
                                return false;
                            }
                        }

                        setTimeout(function () {
                            top.postMessage(
                                { 
                                    ready: 1, 
                                    data: { 
                                        button_url: data.button, 
                                        tooltip: data.tooltip, 
                                        greeting: data.greeting, 
                                        position: data.position, 
                                        margin_bottom: data.margin_bottom, 
                                        margin_side: data.margin_side,
                                        z_index: data.z_index
                                    },
                                    check_domain:response.data.data.check_domain,
                                    website_url:response.data.data.page_info.website_url, 
                                    languages : response.data.data.languages 
                                },
                                document.referrer
                            );
                        }, data.timestart * 1000);
                        $self.page = data;
                        this.$store.commit('set_page', data);
                        if (data.onoff_surver == '1' || data.onoff_surver == 1) {
                            $self.has_survey = true;
                            // $self.first_component = 'survey';
                        } else {
                            $self.has_survey = false;
                            // $self.first_component = 'chat';
                        }

                        var livechat_lang = livechat.getSetttinglocalStorage(livechat.getId() + '_omnichat', 'setting_language');
                        if (livechat_lang) {
                            this.$store.commit('set_lang', livechat_lang);
                            $self.$i18n.locale = livechat_lang;
                        } else {
                            this.$store.commit('set_lang', this.convertLang(data.lang));
                            $self.$i18n.locale = this.convertLang(data.lang);
                            livechat.setSettingLanguage($self.convertLang(data.lang));
                        }

                        if (typeof $self.page.data_field !== "undefined") {
                            var languageOptions = [];
                            $self.page.data_field.forEach(function (item) {
                                languageOptions.push(item);
                            })
                            if(languageOptions.length) livechat.setLanguage('vi', {data_field: languageOptions});
                        }

                        livechat.setLanguage('vi',
                        {
                            title_agentname_text: $self.page.title_agentname_text,
                            title_begin_chat: $self.page.title_begin_chat,
                            title_instruction_text: $self.strReplace($self.page.title_instruction_text),
                            title_ready_ask_us_text: $self.page.title_ready_ask_us_text,
                            title_ready_busy_text: $self.page.title_ready_busy_text,
                            title_ready_enter_text: $self.page.title_ready_enter_text,
                            title_ready_text: $self.page.title_ready_text,
                            title_ready_welcome_text: $self.page.title_ready_welcome_text,
                            title_survey_heading: $self.page.title_survey_heading
                            // data_field: $self.page.data_field,
                        });

                        // if (data.lang == 'vi-VN' || data.lang == 'vi-VI') {
                        //     // $self.$i18n.locale = 'vn';
                        //     // this.$store.commit('set_lang', 'vn');
                        //     livechat.setLanguage('vi',
                        //         {
                        //             title_agentname_text: $self.page.title_agentname_text,
                        //             title_begin_chat: $self.page.title_begin_chat,
                        //             title_instruction_text: $self.page.title_instruction_text,
                        //             title_ready_ask_us_text: $self.page.title_ready_ask_us_text,
                        //             title_ready_busy_text: $self.page.title_ready_busy_text,
                        //             title_ready_enter_text: $self.page.title_ready_enter_text,
                        //             title_ready_text: $self.page.title_ready_text,
                        //             title_ready_welcome_text: $self.page.title_ready_welcome_text,
                        //             title_survey_heading: $self.page.title_survey_heading,
                        //             data_field: $self.page.data_field,

                        //             error_field_required: "Vui lòng nhập {field}",
                        //             error_field_length: "{field} không dài quá {length} ký tự",
                        //             /*name: "",
                        //             phone: $self.page.title_survey_heading,
                        //             email: $self.page.title_survey_heading, setup cho survey*/
                        //         });

                        // } 
                        // else {
                        //     // $self.$i18n.locale = 'en';
                        //     // this.$store.commit('set_lang', 'en');
                        //     livechat.setLanguage('en',
                        //         {
                        //             title_agentname_text: $self.page.title_agentname_text,
                        //             title_begin_chat: $self.page.title_begin_chat,
                        //             title_instruction_text: $self.page.title_instruction_text,
                        //             title_ready_ask_us_text: $self.page.title_ready_ask_us_text,
                        //             title_ready_busy_text: $self.page.title_ready_busy_text,
                        //             title_ready_enter_text: $self.page.title_ready_enter_text,
                        //             title_ready_text: $self.page.title_ready_text,
                        //             title_ready_welcome_text: $self.page.title_ready_welcome_text,
                        //             title_survey_heading: $self.page.title_survey_heading,
                        //             data_field: $self.page.data_field,

                        //             error_field_required: "{field} is a required field",
                        //             error_field_length: "{field} must not be greater than {length} characters long",
                        //             /*name: "",
                        //             phone: $self.page.title_survey_heading,
                        //             email: $self.page.title_survey_heading, setup cho survey*/
                        //         }
                        //     );
                        //     // window.livechat.setSettingLanguage('en');


                        // }

                        if (typeof $self.page.languages !== "undefined") {
                            for (var lang in $self.page.languages) {
                                livechat.setLanguage(lang, $self.page.languages[lang]);
                            }

                        }
                       

                        /*if ($self.lsTest() === true) {
                            var st_token = livechat.getSetttinglocalStorage(livechat.getId() + '_omnichat', 'st_token');
                            if (st_token) {
                                // $self.first_component = 'chat';
                                $self.$store.commit('set_first_component', 'chat');
                                $self.$store.commit('set_token', st_token);
                            }
                        }*/

                        

                        //people
                        /*var people_data = data.people_info;
                        if (!$self.has_channel && people_data!=null) {
                          $self.first_component = 'chat';
                          window.user.setName(people_data.name);
                          window.user.setPhone(people_data.phone);
                          window.user.setEmail(people_data.email);
                          window.user.setAddress(people_data.address);
                        }else if($self.has_channel){
                          $self.first_component = 'channel';
                        }else{
                          if (window.livechat.hasUserdata) {
                            $self.first_component = 'chat';
            
                          }else{
                            $self.first_component = 'survey';
                          }                
                        }*/

                        // $self.first_component = 'survey';//tam thoi test

                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            generate_uuid4: function() {
              var dt = new Date().getTime();
              var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (dt + Math.random()*16)%16 | 0;
                dt = Math.floor(dt/16);
                return (c=='x' ? r :(r&0x3|0x8)).toString(16);
              });
              return uuid;
            },
            get_user_info(user_id){
                var $self = this;
                axios.post('/app/v1/public/v2/getUserPeopleInfo',{
                    livechat_id:livechat.getId(),
                    user_id: user_id,
                    survey_data: {name:window.user.name, phone:window.user.phone, email:window.user.email, address:window.user.address}, 
                    properties:window.user.properties, 
                    livechat_id: livechat.getId(), 
                    st_token: $self.st_token, 
                    conversation_language:livechat.getSetttinglocalStorage(livechat.getId()+'_omnichat', 'setting_language')
                }).then((response) => {
                    if (response.data.status==1) {
                        $self.$store.commit('set_token', response.data.data.st_token);
                        $self.$store.commit('set_first_component', 'chat');
                        $self.first_component = 'chat';
                        livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'st_token', response.data.data.st_token);
                        window.livechat.setSettingNoti(true);

                        setTimeout((function(){
                            $self.first_component = 'chat';
                        }),300);

                        livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'user_id', user_id);
                        return response.data.data.st_token;
                    }else if (response.data.status == -1) {
                        top.postMessage(
                            { 
                                hide_button: 1, 
                            },
                            document.referrer
                        );
                        return '';
                    }else{
                        // var st_token = livechat.getSetttinglocalStorage(livechat.getId()+'_omnichat', 'st_token');
                        // if (st_token) {
                        //     // $self.first_component = 'chat';
                        //     $self.$store.commit('set_first_component', 'chat');
                        //     $self.$store.commit('set_token', st_token);
                        // }
                        // else{
                            var generate_uuid4 = $self.generate_uuid4();
                            $self.$store.commit('set_token', generate_uuid4);
                            if ($self.page.onoff_surver == 1) {
                                $self.$store.commit('set_first_component', 'survey');
                                // $self.$store.commit('set_token', '');
                            }
                            if ($self.page.onoff_surver!='1') {
                                // $self.has_survey = false;
                                $self.$store.commit('set_first_component', 'chat');
                            }
                        // }

                        livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'user_id', user_id);
                        return '';
                    }
                }).catch(error => {
                    console.log(error);
                });

            },
            showLauncher: function (e) {
                $('.h-btn').toggleClass('zoomOut');
                $('.hotline-launcher').toggle();
                this.new_message_number = 0;
                if ($('.hotline-launcher').is(":visible")) {
                    top.postMessage({ st_popup_status: 1 }, document.referrer);
                    this.$store.commit('set_show_launcher', 1);
                } else {
                    top.postMessage({ st_popup_status: 0 }, document.referrer);
                    this.$store.commit('set_show_launcher', 0);
                }
            },
            convertLang: function (userLang) {
                switch (userLang) {
                    case 'vi-VN':
                        return 'vi';
                        break;
                    case 'en-US':
                        return 'en';
                        break;
                    case 'zh-CN':
                        return 'zh-CN';
                        break;
                    default:
                        return 'vi';
                }
            },
            swithLang: function (val) {
                var $self = this;
                // window.livechat.setSettingLanguage($self.lang);
                var langs = window.livechat.getLanguages();
                $self.$i18n.locale = val;

                /*langs.forEach(function(element){
                  $self.$i18n.locale = val;
                  // window.livechat.setSettingLanguage(val);
          
                  if (element.code == val ) {
                    $self.$i18n.locale = val;
                    if (element.title_ready_enter_text) {
                      $self.page.title_ready_enter_text = element.title_ready_enter_text;
                    }
                  }
                });*/
            },
            uid() {
                return (performance.now().toString(36) + Math.random().toString(36)).replace(/\./g, "");
            },
            setLang: function (val) {
                var $self = this;
                this.setting_language = val;
                window.livechat.setSettingLanguage(val);
                this.$store.commit('set_lang', val);
                $self.$i18n.locale = val;

                //send event
                axios.post('/app/v1/public/CHANGE_LANGUAGE', {
                    page_id: livechat.getId(),
                    msg_id: $self.uid(),
                    language: val,
                    sender_id: $self.st_token,
                    name: window.user.name,
                    windowInfo: livechat.windowInfo,
                }).then((response) => {
                }).catch(error => {
                    console.log(error);
                });
            },
            checkconditions(page) {
                var $self = this;
                let conditions = page.conditions;
                let attributes = page.attributes;
                var show_livechat = true;

                conditions.forEach(function (condition) {

                    if (condition.type === 'location') {
                        if (typeof condition.data !== 'undefined' && condition.data.length > 0) {
                            let location_data = condition.data;
                            // attributes.location.city_name = 'Ho Chi Minh City';
                            var index = location_data.findIndex(location => location === attributes.location.city_name);
                            if (parseInt(index) >= 0) {

                            } else {
                                show_livechat = false;
                            }
                        }
                    } else if (condition.type === 'target') {
                        if (typeof condition.data.data_contains !== 'undefined' && condition.data.data_contains.length > 0) {
                            var checkCorretURL = $self.detectCorrectURL(condition.data.data_contains);
                            if (!checkCorretURL) {
                                show_livechat = false;
                            }
                        }

                        if (typeof condition.data.data_except !== 'undefined' && condition.data.data_except.length > 0) {
                            var checkExceptURL = $self.detectExceptURL(condition.data.data_except);
                            if (!checkExceptURL) {

                                show_livechat = false;
                            }
                        }
                    }

                });

                return show_livechat;

            },
            detectCorrectURL: function (urls) {
                var currentURL = window.livechat.windowInfo.href;

                var index = urls.findIndex(url_item => url_item === currentURL);
                if (index != -1) {
                    return true;
                } else {
                    return false;
                }
            },
            detectExceptURL: function (urls) {
                var currentURL = window.livechat.windowInfo.href;
                var index = urls.findIndex(url_item => url_item === currentURL);
                if (index == -1) {
                    return true;
                } else {
                    return false;
                }
            },
            isMobile() {
                /* Storing user's device details in a variable*/
                let details = navigator.userAgent;

                /* Creating a regular expression 
                containing some mobile devices keywords 
                to search it in details string*/
                let regexp = /android|iphone|kindle|ipad/i;

                /* Using test() method to search regexp in details
                it returns boolean value*/
                let isMobileDevice = regexp.test(details);

                if (isMobileDevice) {
                    return true;
                } else {
                    return false;
                }
            },
            lsTest() {
                var test = 'test';
                try {
                    localStorage.setItem(test, test);
                    localStorage.removeItem(test);
                    return true;
                } catch (e) {
                    return false;
                }
            },
        },

    }
</script>
